// PhonePasswordLogin.jsx
import React, { useState, useEffect } from "react";
import { Form, Alert, Button } from "react-bootstrap";
import PhoneInput from "react-phone-number-input";
import { useNavigate } from "react-router-dom";
import { useUserAuth } from "../context/UserAuthContext";
import Logo from "../assets/headerlogo.png";
import DesktopBg from "../assets/signin-bg-desktop.png";
import MobileBg from "../assets/signin-bg-mobile.png";
import "react-phone-number-input/style.css";

export default function PhonePasswordLogin() {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const { verifyPasswordForPhone } = useUserAuth();

  useEffect(() => {
    console.error("[PhoneSignUp] component mounted – you are on the phone sign-in screen (route /)");
    return () => {};
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    // Debug: use console.error so it shows even when console is filtered to "Errors"
    console.error("[PhoneSignUp] onSubmit – phone submitted:", JSON.stringify(phone), "hasPassword:", !!password);
    setError("");
    if (!phone || !password) return setError("Enter phone and password.");

    try {
      setIsSubmitting(true);

      // Verify against DB
      const { ok, user, message } = await verifyPasswordForPhone(phone, password);
  
      if (!ok) {
        throw new Error(message || "Invalid phone or password");
      }
  
      // Check if we have the required user data
      if (!user || !user.token) {
        console.error('Missing user data or token:', user);
        throw new Error("Authentication failed: Missing user data");
      }
  
      // Navigate to home with user data
      navigate("/home", { 
        state: { 
          userData: user,
          // Include any additional data you need
          authToken: user.token
        } 
      });
      
    } catch (e) {
      console.error('Login error:', {
        error: e,
        message: e.message,
        stack: e.stack
      });
      setError(e?.message || "Login failed. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="phone-signup-container" style={{
      minHeight: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: "white",
      padding: "1rem",
      backgroundImage: `url(${DesktopBg})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat"
    }}>
      <div style={{
        backgroundColor: "#181F2A",
        borderRadius: "1rem",
        padding: "2rem",
        width: "100%",
        maxWidth: "400px",
        textAlign: "center",
        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        color: "black"
      }}>
        <img src={Logo} alt="Logo" style={{ height: 100, marginBottom: "1.5rem", marginTop: "1.5rem" }} />
        <h3 style={{ 
          fontFamily: "Halant", 
          marginBottom: ".8rem", 
          color: "white", 
          letterSpacing: '0.15rem', 
          fontSize: '2rem', 
          fontWeight: '500',
          textAlign: 'center',
          marginLeft: '20px'
        }}>
          isabel<sub style={{ fontSize: '0.6rem', verticalAlign: 'sub', marginLeft: '2px' }}>db</sub>
        </h3>
        {error && <Alert variant="danger">{error}</Alert>}

    <Form onSubmit={onSubmit}>

      <Form.Group className="mb-3">
        <PhoneInput
          defaultCountry="NG"
          value={phone}
          onChange={(v) => setPhone(v || "")}
          placeholder="Enter phone number"
          className="custom-phone-input"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Control
          type="password"
          placeholder="Enter password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          // minLength={8}
          required
          className="custom-password-input"
        />
      </Form.Group>

      <Button
        type="submit"
        disabled={isSubmitting}
        onClick={() => console.log("[PhoneSignUp] Sign In button clicked")}
      >
        {isSubmitting ? "Signing in..." : "Sign In"}
      </Button>
    </Form>
    </div>
      {/* Inline style override for react-phone-number-input */}
      <style>{`
        .custom-phone-input input {
          background-color: #181F2A;
          border: 1px solid #F9AA33;
          border-radius: 0.5rem;
          padding: 0.75rem;
          color: white;
          width: 100%;
        }
        .custom-phone-input input::placeholder {
          color: #ccc;
        }
        .custom-password-input {
          background-color: #181F2A;
          border: 1px solid #F9AA33;
          border-radius: 0.5rem;
          padding: 0.75rem;
          color: white;
          width: 100%;  
        }
        .custom-password-input::placeholder {
          color: #ccc;
        }
        /* Responsive background images */
        @media (max-width: 767px) {
          .phone-signup-container {
            background-image: url(${MobileBg}) !important;
          }
        }
        @media (min-width: 768px) {
          .phone-signup-container {
            background-image: url(${DesktopBg}) !important;
          }
        }
      `}</style>
    </div>
  );
}
